import { Map } from "immutable"
import * as React from "react"
import { Region } from "../../custom_api/api"
import DatePicker from "react-datepicker";
import * as Moment from 'moment'
import { ApiResult, isLoaded } from '../../../Shared/api/apiTypes'

export const filterPeriods = ['vandaag', 'morgen', 'komende-zeven-dagen', 'komende-dertig-dagen', 'komend-halfjaar'] as const
export type FilterPeriod = typeof filterPeriods[number]
type FilterPeriodLabels = { [p in FilterPeriod]: string }

export const isFilterPeriod = (input: string): input is FilterPeriod => filterPeriods.includes(input as FilterPeriod)

interface RegionAndDateFilterProps {
  readonly enabled: boolean
  readonly regions: ApiResult<Map<string, Region>>
  readonly selectedPeriod: string
  readonly selectedRegion: string
  readonly selectPeriod: (dateOrPeriod: string) => void
  readonly selectRegion: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

export const periods: FilterPeriodLabels = {
  'vandaag': "vandaag",
  'morgen': "morgen",
  'komende-zeven-dagen': "komende zeven dagen",
  'komende-dertig-dagen': "komende dertig dagen",
  'komend-halfjaar': "komend halfjaar"
}

const PeriodFilter = (p: RegionAndDateFilterProps): JSX.Element => (
  <div className={`o-filter__field form__select form__item--icon left${isFilterPeriod(p.selectedPeriod) ? '' : ' form__select--visually-disabled'}`}>
    <select placeholder="Kies een periode" onChange={(e) => {
      e.stopPropagation()
      p.selectPeriod(e.target.value)
    }} disabled={!p.enabled} value={p.selectedPeriod} id="rd-date">
      {!isFilterPeriod(p.selectedPeriod) && <option>Kies een periode</option>}
      {filterPeriods.map((slug) => <option key={periods[slug]} value={slug}>{periods[slug]}</option>)}
    </select>
    <svg className="form__icon" width="20px" height="22px" aria-hidden="true"><use xlinkHref="#icon--calendar-dnb" /></svg>
  </div>
)

const RegionFilter = (p: RegionAndDateFilterProps): JSX.Element => (
  <div className="o-filter__field form__select form__item--icon left">
    <select onChange={p.selectRegion} value={p.selectedRegion} disabled={!p.enabled} id="rd-region">
      <option key="overal" value="">overal</option>
      {isLoaded(p.regions) && p.regions
        .sort()
        .map((x, k) => <option key={x.slug} value={x.slug}>{k}</option>)
        .toArray()}
    </select>
    <svg className="form__icon" width="20px" height="24px" aria-hidden="true"><use xlinkHref="#icon--pin-dnb" /></svg>
  </div>
)

export const RegionAndDateFilter = (props: RegionAndDateFilterProps): JSX.Element =>
  <fieldset className="o-filter o-filter--two">
    <legend className="sr-text">Filter activiteiten op datum en plaats</legend>
    <div className="o-filter__inner">
      <div className="o-filter__item">
        <label className="o-filter__label text--s" htmlFor="rd-date">Wanneer?</label>
        <PeriodFilter {...props} />
      </div>
      <div className="o-filter__item">
        <label className="o-filter__label text--s" htmlFor="rd-region">Waar?</label>
        <RegionFilter {...props} />
      </div>
    </div>
  </fieldset>

export const RegionAndDateFilterWithDatePicker = (props: RegionAndDateFilterProps): JSX.Element => {
  const { selectedPeriod, selectPeriod } = props
  const moment = Moment(selectedPeriod, 'DD-MM-YYYY')
  const date = moment.isValid() ? moment.toDate() : null

  return (
    <fieldset className="o-filter o-filter--three">
      <legend className="sr-text">Filter activiteiten op datum en plaats</legend>
      <div className="o-filter__inner">
        <div className="o-filter__item">
          <label className="o-filter__label text--s" htmlFor="rd-date">Wanneer?</label>
          <PeriodFilter {...props} />
        </div>

        <div className="o-filter__item">
          <label className="o-filter__label text--s" htmlFor="rd-datepicker">Kies een datum</label>
          <div className={`o-filter__field form__select form__item--icon left${isFilterPeriod(selectedPeriod) ? ' form__select--visually-disabled' : ''}`}>
            <DatePicker
              locale="nl"
              dateFormat="dd MMMM yyyy"
              placeholderText="Of kies een dag."
              minDate={new Date()}
              selected={date}
              onChange={(newDate) => selectPeriod(newDate.toLocaleDateString('nl-NL').toString())}
            />
            <svg width="20" height="22" aria-hidden="true"><use xlinkHref="#icon--calendar-dnb" /></svg>
          </div>
        </div>

        <div className="o-filter__item">
          <label className="o-filter__label text--s" htmlFor="rd-region">Waar?</label>
          <RegionFilter {...props} />
        </div>
      </div>
    </fieldset>
  )
}

{/* TH: Added to styleguide! */ }
